import React, { useState } from "react";
import { config } from "../../config/client";
import { Button, Label } from "../../util/ui_components";
import authHeader from "../../services/auth-header";

const DownloadPage = ({ user, language, filename, isDefault }) => {
  const [userEnteredFilename, setUserEnteredFilename] = useState("");

  const handleDownload = async () => {
    try {
      const downloadUrl = `${config.endpoint}/currentDataDownload?filename=${encodeURIComponent(filename)}&isDefault=${isDefault === true}`;
      const response  = await fetch(downloadUrl, { headers: authHeader() });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
  
      const finalFileName = (userEnteredFilename.trim() || filename);
  
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: finalFileName,
          types: [{
            description: "CSV file",
            accept: { "text/csv": [".csv"] }
          }],
        });
        const writable = await handle.createWritable();
        await writable.write(await blob.arrayBuffer());
        await writable.close();
  
      } else {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = finalFileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
      }
  
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download file.");
    }
  };
  

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <div className="flex flex-col items-center justify-center py-10">
        <h1 className="text-3xl font-bold mb-6">Download Dataframe</h1>
        <div className="w-full max-w-md bg-white p-6 rounded shadow-md">
        <Label text="Code to save dataframe to a file :" />
          {language === "Python" && (
            <pre className="mb-4 bg-gray-100 p-4 rounded border border-gray-300 text-sm font-mono">
            df.to_csv('out.csv', index=False)
            </pre>
          )}
          {language === "R" && (
            <pre className="mb-4 bg-gray-100 p-4 rounded border border-gray-300 text-sm font-mono">
            write.csv(df, 'out.csv', row.names = FALSE)
            </pre>
          )}
          <div className="mb-4">
            <Label text="Filename(optional) :" />
            <input
              type="text"
              value={userEnteredFilename}
              onChange={(e) => setUserEnteredFilename(e.target.value)}
              placeholder="Enter desired filename"
              className="w-full mt-2 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div className="flex justify-end">
            <Button
              text="Download"
              onClick={handleDownload}
              width="w-32"
              customStyle={{ padding: "0.5rem 1rem" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
